export type Language = "en" | "es"

export const translations = {
  en: {
    hero: {
      tagline: "Technical Product Manager",
      description: "Bridging [product strategy](italic) and [full-stack execution](white). Scaling SaaS and AI systems.",
      viewProjects: "View Projects",
      downloadCv: "Download Full CV",
      cvPath: "/Diego_Nunez_CV_Technical_Product_Manager.pdf",
      available: "Available for Global Remote"
    },
    about: {
      label: "About Me",
      reveal: "I operate at the edge of code and commerce. A Product Engineer bridging 12+ years of strategy with full-stack execution.",
      leadership: "Engineering Leadership",
      leadershipDesc: "Led Peru operations for a Singaporean B2B marketplace, coordinating distributed product teams across China and LATAM.",
      impact: "Scaled Impact",
      impactDesc: "Scaled an Argentinian SaaS platform from 1K to 4K active stores, managing $2M+ ARR and executing a successful 2024 acquisition."
    },
    works: {
      label: "Professional Experience",
      title: "Selected Experience",
      impactLabel: "Key Impact",
      projects: [
        {
          year: "2025 — 2026",
          role: "Country Manager Peru",
          company: "Nxin, Singapore",
          description: "Led regional operations for a cross-border B2B agriculture marketplace. Built the LATAM commercial operating system from zero.",
          impact: "Constructed verified databases of 4,200+ companies using Python-based commercial intelligence.",
          tech: ["Python", "Pandas", "Supabase", "SCRUM"]
        },
        {
          year: "2020 — 2025",
          role: "Product & Marketing Tech Manager",
          company: "Atrae+, Lima",
          description: "Orchestrated delivery of 20+ full-stack platforms and launched qola.app. Designed AI-enabled automation pipelines.",
          impact: "Built autonomous lead capture systems reducing manual qualification by 60%.",
          tech: ["React", "PHP", "WordPress", "n8n", "OpenAI"]
        },
        {
          year: "2012 — 2015",
          role: "General Manager — Peru",
          company: "Wobiz / Neositios",
          description: "Spearheaded technical and commercial expansion of a SaaS e-commerce builder. Managed operations for 5,000+ SMB customers.",
          impact: "Scaled store base by 300% (1K to 4K active stores) and contributed to 2024 acquisition.",
          tech: ["SaaS Scaling", "E-commerce", "Strategic Partnerships"]
        }
      ]
    },
    stack: {
      label: "Technical Stack"
    },
    nav: {
      about: "About",
      experience: "Experience",
      stack: "Stack",
      contact: "Contact",
      aiContext: "AI Context",
      portfolioLabel: "Portfolio // Projects",
      projectsSubtitle: "// Featured",
      projectsTitle: "Projects",
      back: "Back"
    },
    vault: {
      title: "Contact",
      subtitle: "LET'S TALK",
      nameLabel: "Name",
      emailLabel: "Email",
      messageLabel: "How can I help?",
      submit: "Send Message",
      sending: "Sending...",
      success: "Message Sent",
      error: "Error. Please try again.",
      whatsappIntro: "Hi Diego, my name is",
      whatsappObjective: "I'd like to discuss:",
      redirecting: "Redirecting to WhatsApp..."
    },
    footer: {
      cta: "Let's Collaborate"
    }
  },
  es: {
    hero: {
      tagline: "Technical Product Manager",
      description: "Uniendo [estrategia de producto](italic) y [ejecución full-stack](white). Escalando sistemas SaaS e IA.",
      viewProjects: "Ver Proyectos",
      downloadCv: "Descargar CV Completo",
      cvPath: "/Diego_Nunez_CV_Technical_Product_Manager.pdf",
      available: "Disponible para Remoto Global"
    },
    about: {
      label: "Sobre Mí",
      reveal: "Opero en el límite entre el código y el comercio. Product Engineer uniendo 12+ años de estrategia con ejecución full-stack.",
      leadership: "Liderazgo de Ingeniería",
      leadershipDesc: "Lideré operaciones en Perú para un marketplace B2B de Singapur, coordinando equipos distribuidos en China y LATAM.",
      impact: "Impacto Escalado",
      impactDesc: "Escalé una plataforma SaaS Argentina de 1K a 4K tiendas activas, gestionando $2M+ ARR y ejecutando una adquisición exitosa en 2024."
    },
    works: {
      label: "Trayectoria Profesional",
      title: "Experiencia Seleccionada",
      impactLabel: "Impacto Clave",
      projects: [
        {
          year: "2025 — 2026",
          role: "Country Manager Perú",
          company: "Nxin, Singapur",
          description: "Lideré operaciones regionales para un marketplace B2B agrícola. Construí el sistema operativo comercial de LATAM desde cero.",
          impact: "Construcción de bases de datos verificadas de 4,200+ empresas usando inteligencia comercial en Python.",
          tech: ["Python", "Pandas", "Supabase", "SCRUM"]
        },
        {
          year: "2020 — 2025",
          role: "Gerente de Producto y Marketing Tech",
          company: "Atrae+, Lima",
          description: "Orchesté la entrega de más de 20 plataformas full-stack y lancé qola.app. Diseñé flujos de automatización con IA.",
          impact: "Sistemas autónomos de captura de leads reduciendo la calificación manual en un 60%.",
          tech: ["React", "PHP", "WordPress", "n8n", "OpenAI"]
        },
        {
          year: "2012 — 2015",
          role: "Gerente de Producto Lead — Perú",
          company: "Wobiz / Neositios",
          description: "Lideré la expansión técnica y comercial de un constructor de e-commerce SaaS. Gestioné operaciones para 5,000+ PYMEs.",
          impact: "Escalé la base de tiendas en un 300% (1K a 4K) y contribuí a la adquisición en 2024.",
          tech: ["Escalamiento SaaS", "E-commerce", "Alianzas Estratégicas"]
        }
      ]
    },
    stack: {
      label: "Stack Tecnológico"
    },
    nav: {
      about: "Sobre mí",
      experience: "Experiencia",
      stack: "Stack",
      contact: "Contacto",
      aiContext: "Contexto IA",
      portfolioLabel: "Portafolio // Proyectos",
      projectsSubtitle: "// Destacados",
      projectsTitle: "Proyectos",
      back: "Volver"
    },
    vault: {
      title: "Contacto",
      subtitle: "HABLEMOS",
      nameLabel: "Nombre",
      emailLabel: "Correo",
      messageLabel: "¿En qué puedo ayudarte?",
      submit: "Enviar Mensaje",
      sending: "Enviando...",
      success: "Mensaje Enviado",
      error: "Error. Intenta de nuevo.",
      whatsappIntro: "Hola Diego, mi nombre es",
      whatsappObjective: "Quisiera hablar sobre:",
      redirecting: "Redirigiendo a WhatsApp..."
    },
    footer: {
      cta: "Hablemos"
    }
  }
}
